import { render, staticRenderFns } from "./ActivityPanel.vue?vue&type=template&id=1b5890da&scoped=true"
import script from "./ActivityPanel.vue?vue&type=script&lang=js"
export * from "./ActivityPanel.vue?vue&type=script&lang=js"
import style0 from "./ActivityPanel.vue?vue&type=style&index=0&id=1b5890da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5890da",
  null
  
)

export default component.exports